module.exports = __webpack_public_path__ + "static/media/9H.33ab7891.png";